// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../../Assets/images/accueil-abonnements-matching-plat.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.abonnement_background{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center top;
    padding: 4% 3%;
}

@media (max-width: 768px) {
    .abonnement_background{
      padding: 100px 30px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/SubscriptionsPage/Subscriptions/Components/SubscriptionCard/CombinedSubscriptionSection.css"],"names":[],"mappings":"AAAA;IACI,yDAA+F;IAC/F,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI;MACE,mBAAmB;IACrB;EACF","sourcesContent":[".abonnement_background{\n    background-image: url(../../../../../../../Assets/images/accueil-abonnements-matching-plat.png);\n    background-size: cover;\n    background-position: center top;\n    padding: 4% 3%;\n}\n\n@media (max-width: 768px) {\n    .abonnement_background{\n      padding: 100px 30px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
